export default __webpack_public_path__ + "static/art_gallery_2-b740916142b80f63664de147bb356038.png";